import { useAuth } from '../../contexts/AuthContext';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import Loading from '../Loading';

interface ErrorPageProps {
  title?: string;
  message?: string;
  showBackButton?: boolean;
  redirectURL?: string;
  buttonText?: string;
  icon?: React.ReactNode;
  messageBoxColor?: string;
  messageTextColor?: string;
}

const ErrorPage = ({
  title = "Page does not exist",
  message = "The page you're looking for doesn't exist or may have been moved.",
  showBackButton = true,
  redirectURL = '/',
  buttonText = 'Close',
  icon = <ExclamationCircleIcon className="w-12 h-12 mx-auto text-red-500" />,
  messageBoxColor = 'border-red-200 bg-red-50',
  messageTextColor = 'text-red-800',
}: ErrorPageProps) => {
  const { isLoading } = useAuth();

  if (isLoading) { return <Loading message="Loading Authentication..." />; }

  const handleGoBack = () => { window.location.href = redirectURL; };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-700">
      <div className="bg-white rounded-lg p-6 max-w-md w-full text-center">
        {icon}

        <h1 className="text-xl font-medium text-gray-800 mb-4">{title}</h1>

        <div className={`border ${messageBoxColor} rounded-md p-4 mb-6 text-left`}>
          <p className={`text-md ${messageTextColor}`}>
            {message}
          </p>
        </div>

        {showBackButton && (
          <button
            onClick={handleGoBack}
            className="w-full bg-brand-600 hover:bg-brand-700 text-white font-medium py-2 rounded transition duration-200"
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
